module.exports = __webpack_public_path__ + "static/media/foukou.c3b12cff.jpg";